export const DEFAULT_QTY = 1;
export const DOC_TIER1 = 4;
export const DOC_TIER2 = 5;
export const DOC_TIER3 = 51;
export const DOC_TIER4 = 101;
export const DOC_TIER5 = 201;
export const DOC_TIER6 = 401;
export const DOC_TIER7 = 1001;

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30N9J = '30N9J';

// Product Title & page url for creating CIs
export const productTitle = 'Guradium Insignts Price Calculator';
export const pageUrl = '/products/guardium-insights/pricing';
export const pageTitle = 'Guradium Insignts Pricing Page';
export const object = 'Guradium Insignts for Cloud';
export const location = 'Pricing Page';
